/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------

import { Point, isPoint } from "@cartographerio/geometry";
import {
  MapId,
  isMapId,
  MapLayerId,
  isMapLayerId,
  NamedEmail,
  isNamedEmail,
  Subdomain,
  isSubdomain,
  SurveyModuleId,
  isSurveyModuleId,
  WorkspaceId,
  isWorkspaceId,
} from "../core/types.generated";
import { MapTiles, isMapTiles } from "../map/types.generated";

export type WorkspaceFeature = "MultiProject" | "OfflineMaps";

export interface WorkspaceV1 {
  name: string;
  subdomain: Subdomain;
  operator?: string | null;
  homepage?: string | null;
  logo?: string | null;
  privacyPolicy?: string | null;
  surveys: SurveyModuleId[];
  layers: MapLayerId[];
  maps: MapId[];
  features?: WorkspaceFeature[] | null;
  sendSurveyCompleteEmails: boolean;
  sendSurveyApprovedEmails: boolean;
  notificationEmails?: NamedEmail[] | null;
  supportEmails?: NamedEmail[] | null;
  allowAnonymousSignup: boolean;
  mapCenter: Point;
  mapZoom: number;
  mapTiles: MapTiles;
  id: WorkspaceId;
}

export interface WorkspaceV2 {
  name: string;
  slug: Subdomain;
  operator?: string | null;
  homepage?: string | null;
  logo?: string | null;
  privacyPolicy?: string | null;
  features: WorkspaceFeature[];
  id: WorkspaceId;
}

export type WorkspaceSearchRoleParam = "all" | "registered" | "active";

export const isWorkspaceFeature = (v: any): v is WorkspaceFeature => {
  return v === "MultiProject" || v === "OfflineMaps";
};

export const isWorkspaceV1 = (v: any): v is WorkspaceV1 => {
  return (
    typeof v === "object" &&
    v != null &&
    "name" in v &&
    typeof v.name === "string" &&
    "subdomain" in v &&
    isSubdomain(v.subdomain) &&
    (!("operator" in v) ||
      typeof v.operator === "string" ||
      v.operator === null) &&
    (!("homepage" in v) ||
      typeof v.homepage === "string" ||
      v.homepage === null) &&
    (!("logo" in v) || typeof v.logo === "string" || v.logo === null) &&
    (!("privacyPolicy" in v) ||
      typeof v.privacyPolicy === "string" ||
      v.privacyPolicy === null) &&
    "surveys" in v &&
    Array.isArray(v.surveys) &&
    v.surveys.every((i: any) => isSurveyModuleId(i)) &&
    "layers" in v &&
    Array.isArray(v.layers) &&
    v.layers.every((i: any) => isMapLayerId(i)) &&
    "maps" in v &&
    Array.isArray(v.maps) &&
    v.maps.every((i: any) => isMapId(i)) &&
    (!("features" in v) ||
      (Array.isArray(v.features) &&
        v.features.every((i: any) => isWorkspaceFeature(i))) ||
      v.features === null) &&
    "sendSurveyCompleteEmails" in v &&
    typeof v.sendSurveyCompleteEmails === "boolean" &&
    "sendSurveyApprovedEmails" in v &&
    typeof v.sendSurveyApprovedEmails === "boolean" &&
    (!("notificationEmails" in v) ||
      (Array.isArray(v.notificationEmails) &&
        v.notificationEmails.every((i: any) => isNamedEmail(i))) ||
      v.notificationEmails === null) &&
    (!("supportEmails" in v) ||
      (Array.isArray(v.supportEmails) &&
        v.supportEmails.every((i: any) => isNamedEmail(i))) ||
      v.supportEmails === null) &&
    "allowAnonymousSignup" in v &&
    typeof v.allowAnonymousSignup === "boolean" &&
    "mapCenter" in v &&
    isPoint(v.mapCenter) &&
    "mapZoom" in v &&
    typeof v.mapZoom === "number" &&
    "mapTiles" in v &&
    isMapTiles(v.mapTiles) &&
    "id" in v &&
    isWorkspaceId(v.id)
  );
};

export const isWorkspaceV2 = (v: any): v is WorkspaceV2 => {
  return (
    typeof v === "object" &&
    v != null &&
    "name" in v &&
    typeof v.name === "string" &&
    "slug" in v &&
    isSubdomain(v.slug) &&
    (!("operator" in v) ||
      typeof v.operator === "string" ||
      v.operator === null) &&
    (!("homepage" in v) ||
      typeof v.homepage === "string" ||
      v.homepage === null) &&
    (!("logo" in v) || typeof v.logo === "string" || v.logo === null) &&
    (!("privacyPolicy" in v) ||
      typeof v.privacyPolicy === "string" ||
      v.privacyPolicy === null) &&
    "features" in v &&
    Array.isArray(v.features) &&
    v.features.every((i: any) => isWorkspaceFeature(i)) &&
    "id" in v &&
    isWorkspaceId(v.id)
  );
};

export const isWorkspaceSearchRoleParam = (
  v: any
): v is WorkspaceSearchRoleParam => {
  return v === "all" || v === "registered" || v === "active";
};

/* eslint-enable @typescript-eslint/explicit-module-boundary-types */
/* eslint-enable @typescript-eslint/no-use-before-define */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable @typescript-eslint/no-explicit-any */
/* eslint-enable @typescript-eslint/no-empty-interface */
